// extracted by mini-css-extract-plugin
module.exports = {"SortInput":"sortInput_SortInput__1VaKb","title":"sortInput_title__1TMA_","arrow":"sortInput_arrow__2Wvmv","activeArrow":"sortInput_activeArrow__3TgIm"};